import { useEffect, useState, useRef } from "react";
import {
  Box,
  Checkbox,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  FormControlLabel,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import * as Icons from "@material-ui/icons";
import Input from "../../Input";
import InputNumberField from "../../InputNumberField";
import CloseIcon from "@material-ui/icons/Close";
import { colors } from "../../../theme/variables";
import _ from "lodash";
import SafeEditor from "../../SafeEditor";

const InputParams = (props) => {
  const {
    pageType,
    classes,
    deleteParam,
    index,
    keyVal,
    updateParam,
    param,
    inputParameters,
    changeParamType,
  } = props;
  const [value, setValue] = useState("");
  const [valueType, setValueType] = useState("String");
  const [inputValue, setInputValue] = useState("");
  const [inputError, setInputError] = useState("");
  const [typeError, setTypeError] = useState(false);
  const [isKeyTouched, setIsKeyTouched] = useState(false);

  const handleInputChange = (value) => {
    setInputValue(value);
    if (value && Object.keys(param).includes(value)) {
      setInputError("Key should be unique");
    } else {
      setInputError(false);
    }
  };

  const handleValChange = (e, val) => {
    setValue(val);
  }; //Handlechange is being trigerred when user types or user selects a value from dropdown

  const handleValTypeChange = (e, val) => {
    setValueType(val || "");
    if (!["String", "Number", "Object/Array", "Boolean"].includes(val))
      setTypeError(true);
    else {
      setTypeError(false);
      setInputValue("");
      setValue("");
      updateParam(index, null, null);
    }
  };

  const handleEditorChange = (val) => {
    try {
      const parsedValue = JSON.parse(val);
      setValue(parsedValue);
    } catch (error) {
      console.warn(error);
    }
  };

  useEffect(() => {
    if (!keyVal) return;
    const [key, val] = keyVal;
    setValue(val);
    setInputValue(key);
    const valType = checkHttpParamObjOrArray(val);
    if (valType) setValueType(valType);
  }, [keyVal]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      let finalValue = value;
      if (value || value === null || value === false) {
        if (valueType === "Boolean") {
          finalValue = value && Boolean(value);
        } else if (valueType === "Number") {
          finalValue = Number(value);
        }
        updateParam(index, inputValue, finalValue);
      }
    }, 800);
    return () => clearTimeout(timeout);

    // if(!inputValue){
    //   setInputError("Required.");
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, inputValue, isKeyTouched]);

  const handleKeyFocus = () => {
    setIsKeyTouched(true);
  };

  const checkHttpParamObjOrArray = (val) => {
    let vtype = "";

    if (val || val === false) {
      if (typeof val === "string") {
        vtype = "String";
      } else if (typeof val === "object") {
        vtype = "Object/Array";
      } else if (typeof val === "boolean") {
        vtype = "Boolean";
      } else if (typeof val === "number") {
        vtype = "Number";
      }
      return vtype;
    }
  };

  return (
    <Grid
      container
      spacing={2}
      alignItems="baseline"
      justifyContent="flex-start"
      key={index}
    >
      <Grid item xs={3}>
        <Autocomplete
          disableClearable
          id="output-param-value"
          options={["String", "Number", "Object/Array", "Boolean"]}
          clearOnBlur={false}
          freeSolo
          value={valueType}
          onChange={(e, newVal) => handleValTypeChange(e, newVal)}
          onFocus={handleKeyFocus}
          renderInput={(params) => (
            <TextField
              {...params}
              autoComplete="off"
              variant="outlined"
              label="Type"
              ref={params.InputProps.ref}
              InputProps={{
                ...params.InputParams,
                endAdornment: valueType && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        handleValTypeChange(null, "");
                      }}
                      size="small"
                    >
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
        {!!typeError && (
          <FormControl error={!!typeError}>
            <FormHelperText>Invalid type.</FormHelperText>
          </FormControl>
        )}
      </Grid>

      <Grid item xs={4}>
        <Input
          fullWidth
          value={inputValue}
          onChange={handleInputChange}
          error={!!inputError}
          placeholder="e.g.: Cache-Control..."
          label="Key"
        />
        {!!inputError && (
          <FormControl error={!!inputError}>
            <FormHelperText>{inputError}</FormHelperText>
          </FormControl>
        )}
      </Grid>
      <Grid item xs={valueType === "Object/Array" ? 12 : 4}>
        {/* {valueType === "String" ? ( */}
        {valueType === "String" ? (
          <Autocomplete
            id={`output-param-value-${pageType}-${index}`}
            options={
              inputParameters && inputParameters.length
                ? [
                    // eslint-disable-next-line no-template-curly-in-string
                    "${workflow.input}",
                    ...inputParameters.map(
                      (e) => "${workflow.input." + e + "}"
                    ),
                  ]
                : // eslint-disable-next-line no-template-curly-in-string
                  ["${workflow.input}"]
            }
            clearOnBlur={false}
            freeSolo
            // value={value ? value : keyVal[1] ? keyVal[1] : ""} // value is final value selected from dropdown
            inputValue={value ? value : ""} // current state to be displayed in feild
            // onChange={(e, newVal) => handleValChange(e, newVal)} Event handler for any changes in dropdown
            onInputChange={(e, newVal) => handleValChange(e, newVal)} // This Event handler handles Both Dropdown changes and user typed changes
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                autoComplete="off"
                variant="outlined"
                placeholder="e.g.: max-age=..."
                label="Value"
                ref={params.InputProps.ref}
                InputProps={{
                  ...params.InputParams,
                  endAdornment: value && (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          handleValChange(null, "");
                        }}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        ) : // ) : valueType === "Number" ? (
        valueType === "Number" ? (
          <InputNumberField
            fullWidth
            type="number"
            clearable={true}
            value={value ? value : ""}
            onChange={(e) => handleValChange(e, e)}
            label="Value"
          />
        ) : // ) : valueType === "Boolean" ? (
        valueType === "Boolean" ? (
          <FormControlLabel
            label="Set to true"
            control={
              <Checkbox
                color="primary"
                checked={
                  value ? Boolean(value) && value : Boolean(value) && value
                }
                onChange={(e) => handleValChange(e, e.target.checked)}
              />
            }
          />
        ) : valueType === "Object/Array" ? (
          <Box className={classes.rootBox}>
            <SafeEditor
              className={classes.monaco}
              height="120px"
              width="100%"
              theme="vs-light"
              language="json"
              value={value ? JSON.stringify(value) : ""}
              autoIndent={true}
              // beforeMount={handleEditorWillMount}
              // onMount={handleEditorDidMount}
              // onValidate={handleValidate}
              onChange={handleEditorChange}
              options={{
                tabSize: 2,
                minimap: { enabled: false },
                lightbulb: { enabled: false },
                quickSuggestions: false,

                lineNumbers: "off",
                glyphMargin: false,
                folding: false,
                // Undocumented see https://github.com/Microsoft/vscode/issues/30795#issuecomment-410998882
                lineDecorationsWidth: 0,
                lineNumbersMinChars: 0,
                renderLineHighlight: "none",

                overviewRulerLanes: 0,
                hideCursorInOverviewRuler: true,
                scrollbar: {
                  vertical: "hidden",
                },
                overviewRulerBorder: false,
              }}
            />
          </Box>
        ) : (
          ""
        )}
      </Grid>
      <Grid
        item
        xs={1}
        style={{
          alignSelf: "center",
          marginBottom: inputError || typeError ? "1rem" : "0px",
        }}
      >
        <div
          className={classes.iconContainer}
          onClick={() => deleteParam(index)}
          style={{ color: colors.red07, cursor: "pointer" }}
        >
          <Icons.DeleteOutlineOutlined />
        </div>
      </Grid>
    </Grid>
  );
};

export default InputParams;
